import React, {useEffect, useState, useRef} from "../../../../../__snowpack__/pkg/react.js";
import {Button, Select, Form, Input} from "../../../../../__snowpack__/pkg/antd.js";
import styled from "../../../../../__snowpack__/pkg/styled-components.js";
import {SearchOutlined} from "../../../../../__snowpack__/pkg/@ant-design/icons.js";
import {IconSearch} from "../../../../../__snowpack__/pkg/@genieui-react/icon.js";
import {localeMessage} from "../../i18n.js";
import {useIntlTyped} from "../../../../lib/useIntlTyped.js";
import {debounce} from "../../../../../__snowpack__/pkg/lodash.js";
import {useSearchSkuByWarehouse} from "../../../../entities/inbound/useSearchSkuByWarehouse.js";
export const TableForm = (props) => {
  const {formatMessage, messages} = useIntlTyped(localeMessage);
  const formLanguageMessage = {
    status: formatMessage({id: "documentStatus"}),
    warehouseId: formatMessage({id: "warehouse"}),
    reset: formatMessage({id: "reset"}),
    searchInboundOrderType: formatMessage({id: "filter"})
  };
  Object.assign(messages, formLanguageMessage);
  const {setFormData, form} = props;
  const [_, forceUpdate] = useState([]);
  const [modalFormInstance, setModalFormInstance] = useState(null);
  const tagFormData = Object.assign({}, modalFormInstance && modalFormInstance.getFieldsValue(), form && form.getFieldsValue());
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [skuOptions, setSkuOptions] = useState([]);
  const search = (shouldTrack = true) => {
    form.validateFields().then(async (values) => {
      const allFormValues = Object.assign({}, modalFormInstance && modalFormInstance.getFieldsValue(), values);
      const params = Object.assign({}, allFormValues, {
        keyword: allFormValues.keyword?.trim() || void 0,
        keywordType: allFormValues.keyword?.trim() ? allFormValues.keywordType?.value || void 0 : void 0,
        warehouseId: props.selectedWarehouseId || "",
        isInventoryDistribution: !!(props.orderType === "OUTBOUND" || props.selectedWarehouse?.type === "THIRD_PARTY_WAREHOUSE"),
        variationType: "NORMAL"
      });
      if (props.selectedWarehouse?.type === "THIRD_PARTY_WAREHOUSE") {
        params.pushStatus = "SUCCESS";
      }
      setFormData(params, shouldTrack);
    }).catch((errorInfo) => {
    });
  };
  const closeTagKeyHandler = (closedTag, formInstance, setFormData2) => {
    if (Array.isArray(closedTag.value)) {
      const currentValue = formInstance.getFieldValue(closedTag.key);
      const newValue = currentValue.filter((item) => item.value !== closedTag.value.value);
      formInstance.setFieldsValue(Object.assign({}, {[closedTag.key]: newValue}));
    } else {
      const currentValue = formInstance.getFieldValue(closedTag.key);
      if (Array.isArray(currentValue)) {
        const newValue = currentValue.filter((item) => item.value !== closedTag.value.value);
        formInstance.setFieldsValue(Object.assign({}, {[closedTag.key]: newValue}));
      } else {
        formInstance.resetFields([closedTag.key]);
      }
    }
  };
  const {data: skuList, fetchData: fetchSkuList} = useSearchSkuByWarehouse();
  const debouncedFetchSkuList = useRef(debounce((value, warehouseId) => {
    fetchSkuList({
      warehouseId,
      orderType: "INBOUND_ORDER",
      inventorySku: value
    });
  }, 400));
  useEffect(() => {
    const filteredSkuOptions = skuList.map((item) => ({
      label: item.inventorySku,
      value: item.inventorySku
    }));
    setSkuOptions(filteredSkuOptions);
  }, [skuList]);
  useEffect(() => {
    search(false);
  }, []);
  return /* @__PURE__ */ React.createElement(FormWrapper, null, /* @__PURE__ */ React.createElement(Form, {
    layout: "inline",
    form,
    onValuesChange: (changedValues, allValues) => {
      forceUpdate([]);
    },
    initialValues: {
      keywordType: {
        label: "MSKU",
        value: "SKU_IG_CASE"
      }
    }
  }, /* @__PURE__ */ React.createElement(Input.Group, {
    compact: true,
    style: {width: "auto"}
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    name: "keywordType"
  }, /* @__PURE__ */ React.createElement(Select, {
    labelInValue: true,
    optionLabelProp: "title",
    style: {width: 180},
    className: "select-in-group"
  }, /* @__PURE__ */ React.createElement(Select.Option, {
    value: "SKU_IG_CASE",
    title: "MSKU"
  }, "MSKU"), /* @__PURE__ */ React.createElement(Select.Option, {
    value: "NAME",
    key: "NAME",
    title: formatMessage({id: "productName"})
  }, formatMessage({id: "productName"})))), /* @__PURE__ */ React.createElement(Form.Item, {
    name: "keyword"
  }, /* @__PURE__ */ React.createElement(Input, {
    style: {width: 284},
    suffix: /* @__PURE__ */ React.createElement(IconSearch, {
      width: 18,
      height: 18
    }),
    allowClear: true,
    placeholder: formatMessage({id: "pleaseEnter"})
  }))), /* @__PURE__ */ React.createElement(Button, {
    type: "primary",
    htmlType: "submit",
    style: {borderRadius: 3},
    icon: /* @__PURE__ */ React.createElement(SearchOutlined, null),
    onClick: () => {
      search();
    }
  }, formatMessage({id: "search"}))));
};
const FormWrapper = styled.div`
  padding: 16px;
  background: #f7f8fa;
  .ant-select-selection__choice__content {
    .select-checkbox {
      display: none !important;
    }
  }
  .select-checkbox {
    width: 14px;
    height: 14px;
    position: relative;
    top: -1px;
  }
  .select-in-group {
    .ant-select-selector {
      border-radius: 3px 0 0 3px !important;
    }
  }
  .ant-select-selection-overflow {
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden;
    .ant-select-selection-overflow-item {
      display: none;
    }
    .ant-select-selection-overflow-item:first-child {
      /* width: 224px; */
      display: block;
    }
  }
  .ant-input-affix-wrapper {
    border-radius: 0 3px 3px 0 !important;
  }
`;
